import RiskRatingTab from './RiskRatingTab.container';

export default RiskRatingTab;